import React, { Component, ReactNode, useRef, useState } from "react";
import { View, StyleSheet } from "react-native";
import { withGoogleMap, GoogleMap } from "react-google-maps";
import GoogleMapReact from "google-map-react";
import { Region } from "react-native-maps";

// import Marker from './Marker';
// import Polyline from './Polyline';
// import Callout from './Callout';

export const MapView = ({
  initialRegion,
  onRegionChangeComplete,
  onRegionChange,
  children,
  onClick,
  position,
}: {
  position?: any;
  initialRegion: any;
  onRegionChangeComplete?: (region: Region) => void;
  onRegionChange?: (region: Region) => void;
  children?: ReactNode;
  onClick?: () => void;
}) => {
  const [map, setMap] = useState<any>(null);

  const [zoom, setZoom] = useState(11);

  // console.log("map", map);

  const _getCurrentRegion = () => {
    const center = map.getCenter();
    const bounds = map.getBounds();

    return {
      latitude: center.lat(),
      longitude: center.lng(),
      latitudeDelta: Math.abs(
        bounds.getSouthWest().lat() - bounds.getNorthEast().lat()
      ),
      longitudeDelta: Math.abs(
        bounds.getSouthWest().lng() - bounds.getNorthEast().lng()
      ),
    };
  };

  const onDragStart = () => {
    if (map && onRegionChange) {
      onRegionChange(_getCurrentRegion());
    }
  };

  const onDragEnd = () => {
    if (map && onRegionChangeComplete) {
      onRegionChangeComplete(_getCurrentRegion());
    }
  };

  const onZoomEnd = () => {
    if (map && onRegionChangeComplete) {
      onRegionChangeComplete(_getCurrentRegion());
      setZoom(map.getZoom());
    }
  };

  return (
    <GoogleMapReact
      center={position}
      onGoogleApiLoaded={({ map }) => {
        map.setClickableIcons(false);
        setMap(map);
      }}
      defaultCenter={{
        lat: initialRegion.latitude,
        lng: initialRegion.longitude,
      }}
      onDrag={onDragStart}
      onDragEnd={onDragEnd}
      onZoomAnimationEnd={onZoomEnd}
      // zoom={zoom}
      defaultZoom={zoom}
      onChildClick={(e) => {
        console.log("onChildClick", e);
      }}
      options={{ streetViewControl: false, disableDefaultUI: true }}
      onClick={onClick}
      bootstrapURLKeys={{ key: "AIzaSyB3Y6quV8-iwv1EQvL7U929qBJP815qKVE" }}
    >
      {children}
    </GoogleMapReact>
  );
};

const GoogleMapContainer = withGoogleMap((props) => (
  <GoogleMap {...props} ref={props.handleMapMounted} />
));

class MapView123 extends Component {
  state = {
    center: null,
  };

  handleMapMounted = (map) => {
    this.map = map;
    this.props.onMapReady && this.props.onMapReady();
  };

  getCamera = () => {
    return {
      zoom: this.map.getZoom(),
      center: this.map.getCenter(),
      heading: this.map.getHeading(),
    };
  };

  animateCamera(camera) {
    this.setState({ zoom: camera.zoom });
    this.setState({ center: camera.center });
  }

  animateToRegion(coordinates) {
    this.setState({
      center: { lat: coordinates.latitude, lng: coordinates.longitude },
    });
  }

  _getCurrentRegion = () => {
    const center = this.map.getCenter();
    const bounds = this.map.getBounds();

    return {
      latitude: center.lat(),
      longitude: center.lng(),
      latitudeDelta: Math.abs(
        bounds.getSouthWest().lat() - bounds.getNorthEast().lat()
      ),
      longitudeDelta: Math.abs(
        bounds.getSouthWest().lng() - bounds.getNorthEast().lng()
      ),
    };
  };

  onDragStart = () => {
    const { onRegionChange } = this.props;

    if (this.map && onRegionChange) {
      onRegionChange(this._getCurrentRegion());
    }
  };

  onDragEnd = () => {
    console.log("onRegionChangeComplete");

    const { onRegionChangeComplete } = this.props;
    if (this.map && onRegionChangeComplete) {
      onRegionChangeComplete(this._getCurrentRegion());
    }
  };

  render() {
    const {
      region,
      initialRegion,
      onRegionChange,
      onPress,
      options,
      defaultZoom,
    } = this.props;
    const { center } = this.state;
    const style = this.props.style || styles.container;

    const googleMapProps = center
      ? { center }
      : region
      ? {
          center: {
            lat: region.latitude,
            lng: region.longitude,
          },
        }
      : {
          defaultCenter: {
            lat: initialRegion.latitude,
            lng: initialRegion.longitude,
          },
        };

    const zoom =
      defaultZoom ||
      (region && region.latitudeDelta
        ? Math.round(Math.log(360 / region.latitudeDelta) / Math.LN2)
        : initialRegion && initialRegion.latitudeDelta
        ? Math.round(Math.log(360 / initialRegion.latitudeDelta) / Math.LN2)
        : 15);

    googleMapProps["zoom"] = this.state.zoom ? this.state.zoom : zoom;

    return (
      <View style={style}>
        <GoogleMapContainer
          bootstrapURLKeys={{ key: "AIzaSyB3Y6quV8-iwv1EQvL7U929qBJP815qKVE" }}
          handleMapMounted={this.handleMapMounted}
          containerElement={<div style={{ height: "100%" }} />}
          mapElement={<div style={{ height: "100%" }} />}
          onZoomChanged={() => {
            this.setState({ zoom: this.map.getZoom() });
          }}
          {...googleMapProps}
          onDragStart={this.onDragStart}
          onIdle={this.onDragEnd}
          defaultZoom={zoom}
          onClick={onPress}
          options={options}
        >
          {this.props.children}
        </GoogleMapContainer>
      </View>
    );
  }
}

// MapView.Marker = Marker;
// MapView.Polyline = Polyline;
// MapView.Callout = Callout;

const styles = StyleSheet.create({
  container: {
    height: "100%",
  },
});

export default MapView;
